import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5 } from "styled-components";
import React from "react";
import { getThemeStyle, type Mode, type Theme } from "~/features/ui/get-theme-style";
import { Wrap } from "~/features/ui/wrap";
import { takeFirst } from "~/features/app/utils";
type SectionDataAttrs = Record<`data-${string}`, string | undefined>;
export type BenefitsListBlockViewProps<TItem> = {
  anchor?: Array<{
    id?: string | null;
    name?: string | null;
  }> | {
    id?: string | null;
    name?: string | null;
  } | null;
  getItemKey?: (item: TItem, index: number) => React.Key;
  hasTopDivider?: boolean | null;
  items?: TItem[] | null;
  mode?: string | null;
  renderItem: (item: TItem, index: number) => React.ReactNode;
  sectionProps?: React.ComponentPropsWithoutRef<"section"> & SectionDataAttrs;
  theme?: string | null;
};
export function BenefitsListBlockView<TItem>({
  anchor,
  getItemKey,
  hasTopDivider = true,
  items = [],
  mode = "light",
  renderItem,
  sectionProps,
  theme = "white"
}: BenefitsListBlockViewProps<TItem>) {
  getThemeStyle({
    mode: mode as Mode,
    theme: theme as Theme
  });
  const groups = items ?? [];
  return <_StyledSection {...sectionProps} data-theme={mode as Mode} id={takeFirst(anchor)?.id || undefined} data-anchor-name={takeFirst(anchor)?.name || undefined} $_css={[{
    "position": "relative",
    "backgroundColor": "var(--bg-secondary)",
    "paddingLeft": "var(--spacing-md)",
    "paddingRight": "var(--spacing-md)",
    "paddingTop": "var(--spacing-xl)",
    "paddingBottom": "var(--spacing-xl)",
    "@media (min-width: 1024px)": {
      "paddingLeft": "var(--spacing-xl)",
      "paddingRight": "var(--spacing-xl)",
      "paddingTop": "var(--spacing-2xl)",
      "paddingBottom": "var(--spacing-2xl)"
    }
  }, hasTopDivider && {
    "borderTopWidth": "1px",
    "borderColor": "var(--stroke-primary)"
  }]}>
      <_StyledWrap>
        <_StyledDiv>
          <_StyledDiv2 $_css2={[{
          "position": "relative",
          "zIndex": "10",
          "display": "flex",
          "flexWrap": "wrap",
          "gap": "var(--spacing-md)"
        }]}>
            {groups.map((item, idx) => <_StyledDiv3 key={getItemKey?.(item, idx) || idx} $_css3={[{
            "flex": "1 1 0%",
            "flexShrink": "0",
            "flexBasis": "100%",
            "@media (min-width: 1024px)": {
              "flexBasis": "calc(33.333% - 16px)"
            }
          }]}>
                {renderItem(item, idx)}
              </_StyledDiv3>)}
          </_StyledDiv2>
        </_StyledDiv>
      </_StyledWrap>
    </_StyledSection>;
}
var _StyledSection = /*#__PURE__*/_styled("section").withConfig({
  componentId: "sc-sf-11pigzf-0"
})`${p => p.$_css}`;
var _StyledWrap = _styled2(Wrap).withConfig({
  componentId: "sc-sf-11pigzf-1"
})({
  "borderWidth": "0px"
});
var _StyledDiv = _styled3("div").withConfig({
  componentId: "sc-sf-11pigzf-2"
})({
  "@media (min-width: 1024px)": {
    "paddingLeft": "4rem",
    "paddingRight": "4rem"
  }
});
var _StyledDiv2 = _styled4("div").withConfig({
  componentId: "sc-sf-11pigzf-3"
})`${p => p.$_css2}`;
var _StyledDiv3 = /*#__PURE__*/_styled5("div").withConfig({
  displayName: "benefits-list___StyledDiv3",
  componentId: "sc-y5vaxi-0"
})(["", ""], p => p.$_css3);